const formatDecimal = (value) => {
  return Number(value)?.toLocaleString(undefined, {
    maximumFractionDigits: 5,
    minimumFractionDigits: 0,
  });
};

export default formatDecimal;
